import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import cn from 'classnames';
import { CloseCross, Edit } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { IconButton } from '../IconButton';
import { Column } from '../Layout';
import { Separator } from '../Separator';
import { Typography } from '../Typography';
import styles from './MobileSummaryCard.module.scss';
function renderActionIcon(action) {
    switch(action.type){
        case 'edit':
            return /*#__PURE__*/ _jsx(Edit, {
                size: 18
            });
        case 'remove':
            return /*#__PURE__*/ _jsx(CloseCross, {
                size: 14
            });
    }
}
export const GetMobileSummaryCardTID = (parentTestId)=>getTestIds(parentTestId);
export function MobileSummaryCard(props) {
    const { testId, title, items, titleTestId, error } = props;
    const { MobileSummaryCardTestIds } = useMemo(()=>GetMobileSummaryCardTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        className: cn(styles.root, {
            [styles.error]: error
        }),
        gap: 8,
        testId: testId,
        children: [
            title && /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                skin: "secondary",
                testId: titleTestId,
                children: title
            }),
            (items || []).map((item, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        index > 0 && !item.hideSeparator && /*#__PURE__*/ _jsx(Separator, {
                            spacing: "none",
                            height: "100%",
                            skin: "light",
                            testId: testId ? MobileSummaryCardTestIds.Separator(index) : undefined
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: cn(styles.contentWrapper, {
                                [styles.clickable]: !!item.onClick
                            }),
                            role: item.onClick ? 'button' : undefined,
                            tabIndex: item.onClick ? 0 : undefined,
                            "data-testid": item.rowTestId,
                            onClick: item.onClick,
                            onKeyDown: item.onClick ? (event)=>{
                                if (event.key === 'Enter' || event.key === ' ') {
                                    var _item_onClick;
                                    event.preventDefault();
                                    (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item);
                                }
                            } : undefined,
                            children: [
                                /*#__PURE__*/ _jsxs(Typography, {
                                    ellipsis: !item.disableEllipsis,
                                    className: styles.content,
                                    testId: testId ? MobileSummaryCardTestIds.Content(index) : undefined,
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            skin: "secondary",
                                            testId: item.titleTestId,
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            ellipsis: item.bodyEllipsis,
                                            testId: item.bodyTestId,
                                            children: item.body
                                        })
                                    ]
                                }),
                                item.actions && /*#__PURE__*/ _jsx("div", {
                                    className: styles.actions,
                                    children: item.actions.map((action, index)=>/*#__PURE__*/ _jsx(IconButton, {
                                            noPadding: true,
                                            type: "button",
                                            size: "smallMedium",
                                            className: styles.editButton,
                                            onClick: (event)=>{
                                                var _action_onClick;
                                                event.stopPropagation();
                                                (_action_onClick = action.onClick) === null || _action_onClick === void 0 ? void 0 : _action_onClick.call(action);
                                            },
                                            testId: action.testId,
                                            "aria-label": action.ariaLabel,
                                            bi: action.bi,
                                            children: renderActionIcon(action)
                                        }, index))
                                })
                            ]
                        })
                    ]
                }, index))
        ]
    });
}
